module.exports = __webpack_public_path__ + "img/2024-10-16a_3.a3b25239.jpg";